/**
 * FART F2c — prefetch av produktlenker (upsell-kort, produktkort) så neste produktside er varm ved klikk.
 * Regler (Milad 21.08): eksakt href (inkl. ?variant=) · kun same-origin /products/-lenker (også /collections/x/products/y) ·
 * ALDRI cart/checkout/account/eksterne · dedupliseres · Save-Data / prefers-reduced-data → ingenting · tak på antall.
 * Triggere: (1) intensjon — mus pointerenter / tastatur focusin umiddelbart; touch pointerdown + 150 ms dvele (kanselleres av
 * pointermove/pointercancel = scroll-start); (2) synlighet — kortet ≥ 75 % synlig i
 * ≥ 1 s → prefetch, maks VIEWPORT_TAK per side. Total (intensjon + synlighet) ≤ TOTAL_TAK. Én forespørsel om gangen.
 * Mekanisme: <link rel="prefetch" as="document"> (lav prioritet; Chrome/Edge/Firefox gjenbruker svaret ved navigasjon,
 * også uten cache-control — målt). Der relList ikke støtter prefetch (Safari/WebKit) gjøres INGENTING (ingen fetch-fallback:
 * svaret ville ikke blitt gjenbrukt, bare kostet båndbredde).
 */
(function () {
  'use strict';
  /* Selv-helende vern mot foreldet prefetch-HTML (Codex F2c): endres kurven (Dawns cartUpdate-pubsub) settes et flagg i
   * sessionStorage; en side som leveres fra prefetch-cache (Navigation Timing deliveryType 'cache' / transferSize 0) og ser
   * flagget, henter kurv-boblen på nytt via Section Rendering og fjerner flagget. Kjører på alle sider, også der
   * prefetch ellers er av. Ingen JS-feil hvis pubsub/sessionStorage mangler. */
  try {
    var NOKKEL = 'snatched:cart-dirty';
    var nav = performance.getEntriesByType && performance.getEntriesByType('navigation')[0];
    var fraPrefetch = nav && (nav.deliveryType === 'cache' || (nav.transferSize === 0 && nav.decodedBodySize > 0));
    if (fraPrefetch && sessionStorage.getItem(NOKKEL)) {
      fetch(location.pathname + '?sections=cart-icon-bubble', { credentials: 'same-origin' }).then(function (r) { return r.json(); }).then(function (j) {
        var html = j && j['cart-icon-bubble']; if (!html) return;
        var doc = new DOMParser().parseFromString(html, 'text/html'); var ny = doc.querySelector('#cart-icon-bubble'); var gammel = document.getElementById('cart-icon-bubble');
        if (!(ny && gammel)) return;
        gammel.innerHTML = ny.innerHTML;
        sessionStorage.removeItem(NOKKEL); // fjernes først når DOM faktisk er oppdatert (ellers beholdes retry-muligheten)
        window.__snatchedPrefetchBubbleRefreshed = true;
      }).catch(function () {});
    }
    var merkSkitten = function () { try { sessionStorage.setItem(NOKKEL, '1'); } catch (e) {} };
    var hekt = function () { if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined' && PUB_SUB_EVENTS.cartUpdate) { subscribe(PUB_SUB_EVENTS.cartUpdate, merkSkitten); return true; } return false; };
    if (!hekt()) document.addEventListener('DOMContentLoaded', hekt, { once: true });
    // Belte og bukseseler: også direkte kurv-kall (apper/egen kode) via fetch-observasjon på respons-URL.
    var _fetch = window.fetch; if (typeof _fetch === 'function') { window.fetch = function () { var p = _fetch.apply(this, arguments); try { var u = String(arguments[0] && arguments[0].url || arguments[0] || ''); if (/(?:^|\/)(?:[a-z]{2}(?:-[a-z]{2})?\/)?cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(u.replace(/^https?:\/\/[^/]+/, ''))) p.then(function (r) { if (r && r.ok) merkSkitten(); }, function () {}); } catch (e) {} return p; }; }
  } catch (e) {}
  // Tak (Codex F2c): BYTE-budsjett per side (målt via Resource Timing, estimat 110 KB per dokument før første måling),
  // pluss antallstak. Viewport-stien er av på 3g/2g; intensjon (hover/focus/pointerdown) tillates på 3g.
  var BYTE_TAK = 400 * 1024, ESTIMAT_START = 110 * 1024, VIEWPORT_TAK = 2, TOTAL_TAK = 6, DVELE_MS = 1000, SYNLIG = 0.75;
  var viewportTillatt = true;
  try {
    // Aldri på kurv-/konto-/checkout-sider: server-rendret kurvantall/personalisering i prefetchet HTML kan bli foreldet
    // når kunden endrer kurven før navigasjon (Codex F2c). Produktsider/kolleksjoner har samme risiko bare hvis kurven
    // endres mellom prefetch og klikk — se handoff for måling.
    if (/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(cart|account|checkouts?)(\/|$)/i.test(location.pathname)) return; // også lokalisert: /en/cart, /de/account …
    var conn = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (conn && (conn.saveData || /(^|-)2g/.test(conn.effectiveType || ''))) return;
    if (conn && conn.effectiveType === '3g') viewportTillatt = false;
    if (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches) return;
    var probe = document.createElement('link');
    if (!(probe.relList && probe.relList.supports && probe.relList.supports('prefetch'))) return;
  } catch (e) { return; }

  var sett = Object.create(null), antall = 0, viewportAntall = 0, kø = [], aktiv = false, brukt = 0, storst = 0, produktSett = Object.create(null);
  window.__snatchedPrefetch = { startet: [], hoppet: [], kb: 0 };
  function estimat() { return storst || ESTIMAT_START; }

  function kandidat(a) {
    if (!a || !a.href) return null;
    var u;
    try { u = new URL(a.href, location.href); } catch (e) { return null; }
    if (u.origin !== location.origin) return null;
    if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?(?:collections\/[^/]+\/)?products\/[^/]+\/?$/i.test(u.pathname)) return null;
    if (/cart|checkout|account|orders/i.test(u.pathname)) return null;
    if (u.pathname.replace(/\/$/, '') === location.pathname.replace(/\/$/, '') && u.search === location.search) return null;
    u.hash = '';
    return u.href;
  }
  function prefetch(href, kilde) {
    if (sett[href]) return;
    sett[href] = true; // dedup på eksakt href — logges én gang uansett utfall
    if (antall >= TOTAL_TAK) { window.__snatchedPrefetch.hoppet.push({ href: href, grunn: 'total-tak' }); return; }
    if (brukt + (antall - window.__snatchedPrefetch.startet.length + 1) * estimat() > BYTE_TAK) { window.__snatchedPrefetch.hoppet.push({ href: href, grunn: 'byte-tak' }); return; }
    if (kilde === 'viewport') {
      var sti = href.replace(/[?#].*$/, '');
      if (produktSett[sti]) { window.__snatchedPrefetch.hoppet.push({ href: href, grunn: 'samme-produkt' }); return; }
      if (viewportAntall >= VIEWPORT_TAK) { window.__snatchedPrefetch.hoppet.push({ href: href, grunn: 'viewport-tak' }); return; }
      produktSett[sti] = true; viewportAntall++;
      if (viewportAntall >= VIEWPORT_TAK && stoppObserver) stoppObserver();
    }
    antall++;
    kø.push({ href: href, kilde: kilde }); neste();
  }
  function neste() {
    if (aktiv) return;
    var x = kø.shift(); if (!x) return;
    if (document.visibilityState === 'hidden') { kø.unshift(x); return; }
    if (brukt + estimat() > BYTE_TAK) { window.__snatchedPrefetch.hoppet.push({ href: x.href, grunn: 'byte-tak' }); return; }
    aktiv = true;
    var l = document.createElement('link');
    l.rel = 'prefetch'; l.as = 'document'; l.href = x.href;
    l.onload = l.onerror = function () {
      aktiv = false;
      try { var e = performance.getEntriesByName(x.href).slice(-1)[0]; var b = (e && e.transferSize) || estimat(); brukt += b; if (b > storst) storst = b; window.__snatchedPrefetch.kb = Math.round(brukt / 1024); } catch (err) { brukt += estimat(); }
      setTimeout(neste, 0);
    };
    document.head.appendChild(l);
    window.__snatchedPrefetch.startet.push({ href: x.href.replace(location.origin, ''), kilde: x.kilde, t: Math.round(performance.now()) });
  }
  var stoppObserver = null;
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'visible') neste(); });

  /* (1) intensjon: mus → pointerenter; tastatur → focusin; touch → pointerdown med 150 ms dvele som kanselleres av
   *     pointermove/pointercancel (= scroll-start), så en finger som starter en scroll over et kort ikke utløser prefetch. */
  var lenkeFra = function (e) { var a = e.target && e.target.closest ? e.target.closest('a[href]') : null; return kandidat(a); };
  var intensjon = function (e) { if (e.pointerType === 'touch') return; var h = lenkeFra(e); if (h) prefetch(h, 'intensjon'); };
  document.addEventListener('pointerenter', intensjon, true);
  document.addEventListener('focusin', intensjon, true);
  var touchTimer = null;
  document.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'touch') return; var h = lenkeFra(e); if (!h) return; clearTimeout(touchTimer); touchTimer = setTimeout(function () { prefetch(h, 'intensjon'); }, 150); }, { capture: true, passive: true });
  var avbrytTouch = function () { clearTimeout(touchTimer); touchTimer = null; };
  document.addEventListener('pointermove', function (e) { if (e.pointerType === 'touch') avbrytTouch(); }, { capture: true, passive: true });
  document.addEventListener('pointercancel', avbrytTouch, true);

  /* (2) synlighet: produktlenker i kort (av på 3g) */
  if (!viewportTillatt || !('IntersectionObserver' in window)) return;
  var timere = new WeakMap();
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      var a = en.target;
      if (en.isIntersecting && en.intersectionRatio >= SYNLIG) {
        if (!timere.get(a)) timere.set(a, setTimeout(function () { timere.delete(a); var h = kandidat(a); if (h) prefetch(h, 'viewport'); io.unobserve(a); }, DVELE_MS));
      } else if (timere.get(a)) { clearTimeout(timere.get(a)); timere.delete(a); }
    });
  }, { threshold: [SYNLIG] });
  function observer(root) {
    var lenker = (root || document).querySelectorAll('a.card__content-link[href], a[id^="CardLink-"][href], .product__upsells-item a[href], a.full-unstyled-link[href*="/products/"]');
    for (var i = 0; i < lenker.length; i++) { if (kandidat(lenker[i])) io.observe(lenker[i]); }
  }
  var start = function () { observer(document); var mo = new MutationObserver(function (m) { for (var i = 0; i < m.length; i++) for (var j = 0; j < m[i].addedNodes.length; j++) if (m[i].addedNodes[j].nodeType === 1) observer(m[i].addedNodes[j]); }); mo.observe(document.body, { childList: true, subtree: true }); stoppObserver = function () { try { mo.disconnect(); io.disconnect(); } catch (e) {} }; };
  if (document.readyState === 'complete') setTimeout(start, 1000); else window.addEventListener('load', function () { setTimeout(start, 1000); }, { once: true });
})();
